import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { ProvinceEntity } from 'src/app/core/services/location/domain/entities/province.entity';
import { GetProvinceUseCase } from 'src/app/core/services/location/domain/usecases/get-province.usecase';
import { Failure, UnhandledFailure } from 'src/app/core/utils/failure';
import { GetFileModel } from 'src/app/features/claims/data/models/get-file.model';
import { ClaimCollectiveEntity } from 'src/app/features/claims/domain/entities/claim-colective.entity';
import { ClaimColectiveUseCase } from 'src/app/features/claims/domain/usecases/get-claim-colective-usecase';
import { GetFileColectiveUseCase } from 'src/app/features/claims/domain/usecases/get-file-colective.usecase';
import { MinuteEntity } from 'src/app/features/minutes/domain/entities/minute.entity';
import { GetMinutesByClaimIdUseCase } from 'src/app/features/minutes/domain/usecases/get-minutes-by-claim-id.usecase';
import { DeleteActaUseCase } from 'src/app/features/minutes/domain/usecases/delete-acta.usecase';
import { Location } from '@angular/common';
import { UserRol } from 'src/app/core/enums/user-rol.enum';
import { UpdateClaimStatusModel } from 'src/app/features/claims/data/models/update-claim-status.model';
import { UpdateClaimStatusEntity } from 'src/app/features/claims/domain/entities/update-claim-satus.entity';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { UpdateCollectiveClaimStatusUseCase } from 'src/app/features/claims/domain/usecases/update-collective-status.usecase';
import { GetFileBaseModel } from 'src/app/features/claims/data/models/get-file-base.model';
import { GetFileBaseUseCase } from 'src/app/features/claims/domain/usecases/get-file-base.usecase';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AudiencesService } from 'src/app/features/audiences/services/audiences.service';
import { Departament } from 'src/app/features/user/presentation/components/New-User-SuperAdmin/newUser.component';
import { GetDepartmentsByIdUseCase } from 'src/app/core/services/location/domain/usecases/get-department-by-id.usescase';

@Component({
  selector: 'app-claim-view-colective',
  templateUrl: './claim-view-colective.component.html',
  styleUrls: ['./claim-view-colective.component.css'],
  providers: [MessageService, Toast, ConfirmationService],
})
export class ClaimViewColectiveComponent implements OnInit {
  private AES = new AESEncryptDecryptService();

  claim?: ClaimCollectiveEntity;
  claimForAudience?: ClaimCollectiveEntity;
  claimId?: string | null;
  provinces: ProvinceEntity[] = [];
  claimetProvince?: ProvinceEntity;
  companyProvince?: ProvinceEntity;
  departamentName?: Departament;
  files?: string[];
  displayModal: boolean = false;
  pdfUrl?: string = '';
  minutesForClaim?: MinuteEntity[];
  userRol?: string;
  buttons: boolean = false;

  newStatusClaimUpdate?: UpdateClaimStatusModel;
  labelText: string = 'Aceptar';
  rejectDialogVisible: boolean = false;
  rejectionReason: string = '';
  rejectionFileBase64?: string;

  typeAdmitedClaimDialogVisible: boolean = false;
  resultIntimationAdmited?: boolean;
  typeAdmited: string = '';

  audienciaDialogVisible: boolean = false;
  minuteDialogVisible: boolean = false;
  isLoading: boolean = false;

  isRepresentative: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private claimUseCase: ClaimColectiveUseCase,
    private getProvince: GetProvinceUseCase,
    private getFileUseCase: GetFileColectiveUseCase,
    private getMinutesByClaimIdUseCase: GetMinutesByClaimIdUseCase,
    private deleteActaUseCase: DeleteActaUseCase,
    private location: Location,
    private confirmationService: ConfirmationService,
    private updateClaimStatusUseCase: UpdateCollectiveClaimStatusUseCase,
    private messageService: MessageService,
    private localStorageService: LocalStorageServiceBase,
    private getFileBaseUseCase: GetFileBaseUseCase,
    private getDepartmentsByIdUseCase: GetDepartmentsByIdUseCase
  ) {}

  async ngOnInit(): Promise<void> {
    this.claimId = this.route.snapshot.paramMap.get('id');
    this.userRol = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    await Promise.all([this.getClaim(), this.loadProvinces()]);
    this.setProvinceById();
    this.getMinutesByClaimId();
    this.showButtons();
  }

  async getClaim(): Promise<void> {
    let result = await this.claimUseCase.execute(this.claimId!);
    if (result instanceof Failure) {
      return;
    }
    this.claim = result;
    this.departamentName = await this.laodDepartments(this.claim.departmentId);
    this.isRepresentative =
      this.claim?.rol == UserRol.UNION_REPRESENTATIVE ? true : false;
    this.claimForAudience = Object.assign({}, result);
    this.files = result.claimedFiles;
  }

  async getMinutesByClaimId(): Promise<void> {
    let result = await this.getMinutesByClaimIdUseCase.execute(this.claimId!);
    if (result instanceof Failure) {
      return;
    }
    this.minutesForClaim = result;
  }

  deleteActa(id: string): void {
    this.confirmationService.confirm({
      header: 'Eliminar acta',
      message: '¿Está seguro que desea eliminar el acta?',
      accept: async () => {
        this.isLoading = true;
        let result = await this.deleteActaUseCase.execute(id);
        this.isLoading = false;
        if (result instanceof Failure) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el acta.' });
          return;
        }
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Acta eliminada correctamente.' });
        await this.getMinutesByClaimId();
      },
    });
  }

  showButtons() {
    if (
      this.userRol == UserRol.ADMINISTRATOR ||
      this.userRol == UserRol.CONCILIATOR
    ) {
      this.buttons = true;
    }
  }

  async viewImage(fileName: string) {
    try {
      let fileData = new GetFileModel(this.claim?.id!, fileName);
      this.pdfUrl = await this.getFile(fileData);
      this.displayModal = true;
    } catch (error) {
      this.displayModal = false;
    }
  }

  async getFileBase(param: GetFileBaseModel): Promise<string> {
    let result = await this.getFileBaseUseCase.execute(param);
    if (result instanceof Failure) {
      return result.message;
    }
    return result;
  }

  async getFile(param: GetFileModel): Promise<string> {
    let result = await this.getFileUseCase.execute(param);
    if (result instanceof Failure) {
      return result.message;
    }
    return result;
  }

  async viewMinutePdf(id: string, pdf: string) {
    try {
      let extraDocFiles = new GetFileBaseModel(id, pdf);
      this.pdfUrl = await this.getFileBase(extraDocFiles);
      this.displayModal = true;
    } catch (error) {
      this.displayModal = false;
    }
  }

  getStatusClass(status: string | undefined): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft';
      case ClaimStatus.PENDING:
        return 'status-pending';
      case ClaimStatus.REFUSED:
        return 'status-refused';
      case ClaimStatus.FINALIZED:
        return 'status-finalized';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process';
      case ClaimStatus.AUDIENCE_SET:
      case 'Audiencia Fijada':
        return 'status-audience-set';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  async downloadPdf(pdf: string, minuteId?: string) {
    let base64: string = '';
    if (minuteId) {
      let extraDocFiles = new GetFileBaseModel(minuteId!, pdf);
      base64 = await this.getFileBase(extraDocFiles);
    } else {
      let extraDocFiles = new GetFileModel(this.claim?.id!, pdf);
      base64 = await this.getFile(extraDocFiles);
    }

    let mimeType = 'application/pdf';
    let extension = 'pdf';

    switch (true) {
      case base64.startsWith('iVBORw0KGgo'):
        mimeType = 'image/png';
        extension = 'png';
        break;
      case base64.startsWith('/9j/'):
        mimeType = 'image/jpeg';
        extension = 'jpeg';
        break;
      default:
        mimeType = 'application/pdf';
        extension = 'pdf';
        break;
    }

    const link = document.createElement('a');
    link.href = `data:${mimeType};base64,${base64}`;
    link.download = `document.${extension}`;
    link.click();
  }

  goBack(): void {
    this.location.back();
  }

  recibeAceptDialog(action: string): void {
    if (action == 'Admitir') {
      this.updateAdmittedStatusCheck();
    } else {
      this.updateRefucedStatusCheck();
    }
  }

  newAudienceCheck() {
    this.audienciaDialogVisible = true;
  }

  newMinuteCheck() {
    this.minuteDialogVisible = true;
  }

  cancel(close: any) {
    this.audienciaDialogVisible = false;
    this.minuteDialogVisible = false;
  }

  handleLoadingChange(loading: boolean) {
    this.isLoading = loading;
  }

  handleShowMessage(event: {
    severity: string;
    summary: string;
    detail: string;
  }) {
    this.messageService.add({
      severity: event.severity,
      summary: event.summary,
      detail: event.detail,
    });
  }

  updateAdmittedStatusCheck() {
    this.labelText = 'Admitir reclamo';
    this.confirmationService.confirm({
      header: 'Admitir reclamo',
      message: `¿Desea admitir el reclamo?`,
      accept: () => {
        this.typeAdmitedClaimDialogVisible = true;
      },
    });
  }

  resultIntimationAdmitedEvent(event: boolean) {
    this.resultIntimationAdmited = event;
    if (!this.resultIntimationAdmited) {
      this.newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.ADMITTED
      );
      this.updateClaimStatus(this.newStatusClaimUpdate);
      this.typeAdmitedClaimDialogVisible = false;
    }
  }

  resultTypeAdmitedEvent(event: string) {
    this.typeAdmited = event;
    if (this.typeAdmited) {
      this.newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.ADMITTED,
        undefined,
        this.typeAdmited
      );
      this.updateClaimStatus(this.newStatusClaimUpdate);
      this.typeAdmitedClaimDialogVisible = false;
    }
  }

  async updateClaimStatus(claim: UpdateClaimStatusEntity): Promise<void> {
    this.isLoading = true;
    let result = await this.updateClaimStatusUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Estado no actualizado.',
        life: 900,
      });
      this.isLoading = false;
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Estado actualizado',
      detail: 'El estado se actualizó exitosamente.',
    });
    this.isLoading = false;
    this.getClaim();
  }

  updateRefucedStatusCheck() {
    this.labelText = 'Rechazar reclamo';
    this.confirmationService.confirm({
      header: 'Rechazar reclamo',
      message: `¿Desea rechazar el reclamo?`,
      accept: () => {
        this.rejectDialogVisible = true;
      },
      reject: () => {
        this.rejectionReason = '';
        this.rejectionFileBase64 = undefined;
      },
    });
  }

  confirmRejection() {
    if (this.rejectionReason.trim() || this.rejectionFileBase64) {
      this.newStatusClaimUpdate = new UpdateClaimStatusModel(
        this.claimId!,
        ClaimStatus.REFUSED,
        this.rejectionReason.trim() ? this.rejectionReason : undefined,
        undefined,
        this.rejectionFileBase64 ? [this.rejectionFileBase64] : undefined
      );
      this.updateClaimStatus(this.newStatusClaimUpdate);
      this.rejectDialogVisible = false;
      this.rejectionReason = '';
      this.rejectionFileBase64 = undefined;
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Debe especificar el motivo de rechazo o subir un archivo PDF.',
        life: 2000,
      });
    }
  }

  onRejectionFileUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        this.messageService.add({
          severity: 'error',
          summary: 'Formato incorrecto',
          detail: 'El archivo debe ser un PDF.',
        });
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.rejectionFileBase64 = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      this.rejectionFileBase64 = undefined;
    }
  }

  removeRejectionFile(fileInput: any) {
    this.rejectionFileBase64 = undefined;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  async loadProvinces() {
    try {
      const result = await this.getProvince.execute();
      if (Array.isArray(result)) {
        this.provinces = result;
      }
    } catch (error) {
      throw new UnhandledFailure();
    }
    this.setProvinceById();
  }

  setProvinceById(): void {
    const representativeProvince = this.claim?.representativeProvince;
    this.claimetProvince =
      this.provinces.find((prov) => prov.id === representativeProvince) ||
      this.provinces.find((prov) => prov.name === representativeProvince);
    const provinceCompany = this.claim?.provinceCompany;
    this.companyProvince =
      this.provinces.find((prov) => prov.id === provinceCompany) ||
      this.provinces.find((prov) => prov.name === provinceCompany);
  }

  async laodDepartments(id: string): Promise<Departament | undefined> {
    const result = await this.getDepartmentsByIdUseCase.execute(id);

    if (!(result instanceof Failure)) {
      return result;
    }
    return undefined;
  }

  async downloadAsPdf() {
    const element = document.getElementById('claim-view');
    const downloadButton = document.querySelector(
      'p-button[label="Descargar"]'
    );

    if (!element) return;

    try {
      if (downloadButton) downloadButton.classList.add('hidden');

      const canvas = await html2canvas(element, {
        scale: 1.2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.8);

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = 210;
      const pageHeight = 297;
      const aspectRatio = canvas.width / canvas.height;
      const imgWidth = pageWidth - 20;
      const imgHeight = imgWidth / aspectRatio;
      const xPosition = 10;
      let yPosition = 10;
      let heightLeft = imgHeight;

      pdf.addImage(imgData, 'JPEG', xPosition, yPosition, imgWidth, imgHeight);
      heightLeft -= pageHeight - 20;

      while (heightLeft > 0) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          'JPEG',
          xPosition,
          yPosition - (imgHeight - heightLeft),
          imgWidth,
          imgHeight
        );
        heightLeft -= pageHeight - 20;
      }

      pdf.save('reclamo.pdf');
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Error al descargar el archivo.',
      });
    } finally {
      if (downloadButton) downloadButton.classList.remove('hidden');
    }
  }
}
